import { useParams } from "react-router-dom";

const useAssertParams = <T extends Record<string, string | undefined>>(...keys: (keyof T)[]) => {
  const params = useParams<T>();
  keys.forEach((key) => {
    if (!(key in params)) {
      throw new Error(`Missing parameter: ${String(key)}`);
    }
  });

  return params as T & Record<keyof T, string>;
};

export default useAssertParams;
